export default __webpack_public_path__ + "KaTeX_Main-Bold.20b90c2076172b223ae564a9bb22e0fc.woff2";